import { useEffect, useRef } from 'react';
import { useShallow } from 'zustand/shallow';

import { ArticleEdgeLines } from 'app/modules/wallforming/components/scenes/objects/articles/ArticleEdgeLines';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import {
    isBatchProcessing,
    onBatchComplete
} from 'app/modules/wallforming/components/state-management/placement/slices/connectionSlice';

export const ArticleEdgesOverlay = () => {
    const { articleEdgesOverlay, updateArticleEdgesOverlay, isDraggingActive, edgeLineThickness } = usePlacementStore(
        useShallow((state) => ({
            articleEdgesOverlay: state.articleEdgesOverlay,
            updateArticleEdgesOverlay: state.updateArticleEdgesOverlay,
            isDraggingActive: state.isDraggingActive,
            edgeLineThickness: state.graphicsSettings.edgeLineThickness
        }))
    );

    const edgesNeedUpdateRef = useRef<boolean>(false);

    // External Zustand subscriptions and Three.js resource disposal on unmount.
    useEffect(() => {
        const unsubscribeBatch = onBatchComplete(() => {
            if (edgesNeedUpdateRef.current) {
                edgesNeedUpdateRef.current = false;
                if (isDraggingActive()) {
                    return;
                }
                updateArticleEdgesOverlay();
            }
        });

        const subscribedArticlesChanges = usePlacementStore.subscribe(
            (state) => state.articles,
            () => {
                if (isDraggingActive()) {
                    return;
                }
                if (isBatchProcessing) {
                    edgesNeedUpdateRef.current = true;
                } else {
                    updateArticleEdgesOverlay();
                }
            }
        );

        return () => {
            unsubscribeBatch();
            subscribedArticlesChanges();
        };
    }, [isDraggingActive, updateArticleEdgesOverlay]);

    return <ArticleEdgeLines edgeLineThickness={edgeLineThickness} edgesGeometry={articleEdgesOverlay} />;
};
